module.exports = __webpack_public_path__ + "static/advanced-social-share-54b8f6febf5451308290c059e3acb5ae.png";